import React from 'react';
import { StyledBackground, StyledEllipse, StyledContent, IBackgroundProps } from './Background.styled';

export const Background: React.FC<IBackgroundProps> = ( { children, withImage, unloaded, overlay } ) => {

  return (
    <StyledBackground $backgroundImage={withImage} $unloaded={unloaded} $overlay={overlay}>
      <StyledEllipse />
      <StyledContent>
        {children} 
      </StyledContent>
    </StyledBackground>
  );
}